import { Button, useModal } from "@newsela/angelou";
import PropTypes from "prop-types";

import {
  withTrackEvent,
  objectTypes,
  actionNames,
  actionPrefixes,
} from "@newsela/snitch";
import getUserProperties from "@/users/getUserProperties";
import useUser from "@/users/useUser";
import CreateTextSetModal from "../CreateTextSetModal";
import { buttonWrapper } from "./CreateTextSetButton.style";

const propTypes = {
  buttonProps: PropTypes.object,
  children: PropTypes.node,
  selector: PropTypes.string.isRequired,
  __cssFor: PropTypes.object,
};

const ButtonWithTrackEvent = withTrackEvent(Button);

const CreateTextSetButton = ({ buttonProps, children, selector, __cssFor }) => {
  const [
    createTextSetModalProps,
    setCreateTextSetActive,
    createTextSetTriggerRef,
  ] = useModal(false);
  const { data: user } = useUser();
  const { isStudent } = getUserProperties(user);

  if (isStudent) {
    return <></>;
  }
  if (selector === "created-by-you" || selector === "at-your-school") {
    return (
      <div css={[buttonWrapper, __cssFor?.root]}>
        <ButtonWithTrackEvent
          size={Button.sizes.md}
          flavor={Button.flavors.primary}
          objectType={objectTypes.content}
          actionPrefix={actionPrefixes.initiate}
          actionName={actionNames.create}
          ref={createTextSetTriggerRef}
          onClick={() => setCreateTextSetActive(true)}
          {...buttonProps}
        >
          {children || "+ Create text set"}
        </ButtonWithTrackEvent>
        <CreateTextSetModal
          {...createTextSetModalProps}
          onCancel={() => setCreateTextSetActive(false)}
          onBackgroundClick={() => setCreateTextSetActive(false)}
        />
      </div>
    );
  }
};

CreateTextSetButton.propTypes = propTypes;

export default CreateTextSetButton;
